import {some} from 'lodash';

export default {
  skillsListState(state) {
    return state.skillsList;
  },
  skillsHasValuesState(state) {
    return some(state.skillsList);
  }
};
